import React, {useContext} from 'react';

import {useEventTracking} from 'src/hooks/useEventTracking';
import {AuthenticationContext} from 'src/modules/authentication/authentication-context';

import Button from '@pb/kit-component-button';


import {ErrorPage} from './error-page.components';

export const PageNotFound = () => (
    <ErrorPage
        title="Sorry, the page you are looking for cannot be found"
        subtitle="Please try your search again or contact customer support."
    />
);

export const PermissionDenied = () => {
    const {requestLogout} = useContext(AuthenticationContext);
    const {logout: logoutTrack} = useEventTracking();

    const logout = () => {
        logoutTrack();
        requestLogout(true);
    };

    return (
        <ErrorPage
            title="Access Denied"
            subtitle="You have no access to this page"
            secondaryButton={
                <Button variant="Type.SECONDARY" onClick={logout}>Log out</Button>
            }
        />
    );
};
